<template>
    <div class="contact">
        <div class="contact-image" :style="{ backgroundImage: `url(${contact.image})` }" v-if="contact && contact.image"></div>
        <div class="contact-details" v-if="contact">
            <div class="contact-name">{{ contact.name }}</div>
            <div class="contact-function">{{ contact.function }}</div>
            <div class="contact-phone" v-if="contact.phone">{{ contact.phone }}</div>
        </div>
    </div>
</template>

<script>
import ServiceManager from "../services/service-manager";

export default {
    name: "ContactCard",
    components: {

    },
    props: ["contact"],
    data() {
        return {
            labels: ServiceManager.getService(this, "Labels"),
            config: ServiceManager.getService(this, "Config")
        }
    },
    methods: {
        /*getImageUrl() {
            let url = this.config.defaultContactImage || "";
            if (this.$props.contact && this.$props.contact.image) {
                url = this.$props.contact.image;
            }
            return url;
        }*/
    }
}
</script>

<style scoped>
.contact {
    display: flex;
    align-items: center;
}

.contact-image {
    width: 60px;
    height: 60px;
    min-width: 60px;
    min-height: 60px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 20px;
}

.contact-name {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
}

.contact-function {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 300;
}

.contact-phone {
    font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
    font-weight: 300;
}
</style>
